<h2 mat-dialog-title class="tt-secondary-background" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragBoundary=".cdk-overlay-container" cdkDragHandle style="color: white">
    <span style="width: 100%; display: inline-flex; align-items: center; justify-content: space-between">
        <span ttTranslateWord="dodataimp_import_heading"></span>
        <button (click)="dialogRef.close()" class="tt-button" style="color: white; font-size: var(--tt-font-size-xl); height: fit-content">
            <span class="far fa-times"></span>
        </button>
    </span>
</h2>
<mat-dialog-content>
    <tt-file-data-viewer [(ttFilename)]="filename" [(ttHeaderData)]="headers" [(ttData)]="data"></tt-file-data-viewer>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <tt-button *ngIf="true" class="col-xs-12 col-md-3 sp-0" ttText="dodataimp_save" ttIcon="fas fa-sync-alt" ttType="success" (ttClick)="import()"></tt-button>
</mat-dialog-actions>
